import { Component, Output, EventEmitter, Input, ChangeDetectorRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CxAdvFiltersDataService } from './cx-adv-filters-data.service';
import { CxAdvFiltersService } from './cx-adv-filters.service';
import { ChangeDetectionStrategy } from '@angular/compiler';
import { Field, FilterGroup } from './cx-adv-filters.types';
import { cloneDeep } from './utils';

@Component({
  selector: 'cx-adv-filters',
  templateUrl: './cx-adv-filters.component.html',
})
export class CxAdvFiltersContainerComponent implements OnInit, OnChanges {
  SCREENS = this.advFiltersService.SCREENS;
  @Output() close = new EventEmitter();
  @Output() create = new EventEmitter();
  @Output() update = new EventEmitter();
  @Output() temp = new EventEmitter();
  @Output() check = new EventEmitter();
  @Output() updateview = new EventEmitter();

  
  @Input() selectedView = '';
  @Input() tempView: any;
  @Input() views: any[] = [];
  @Input() fields: any[] = [];
  @Input() module = '';

  constructor(
    public cd: ChangeDetectorRef,
    public advFiltersService: CxAdvFiltersService, 
    public advDataFiltersService: CxAdvFiltersDataService
  ) {
    this.advFiltersService.$close.subscribe((x: string) => {
      const payload: any = {
        ...this.advFiltersService.currentView, 
        filters_group: this.advFiltersService.filters 
      }
      payload.filters_group = payload.filters_group.filter((x: FilterGroup) => !x.deleted).map((x: FilterGroup) => {
        x.filters = x.filters.filter((x: Field) => !x.deleted);
        return x;
      });
      this.close.emit(payload);
    })
  }

  updateTemp (e: any) {
    const payload: any = {
      ...this.advFiltersService.currentView, 
      filters_group: this.advFiltersService.filters 
    }
    payload.filters_group = payload.filters_group.filter((x: FilterGroup) => !x.deleted).map((x: FilterGroup) => {
      x.filters = x.filters.filter((x: Field) => !x.deleted);
      return x;
    });

    this.temp.emit(payload);
  }

  buildCurrentView () {
    let view = this.views.find((x: any) => x.vid === this.selectedView);
    view = view?.native ? { ...view, ...this.tempView } : view;
    
    if (view) {
      view.filters_group = (view.filters_group || []).map((fg: FilterGroup) => {
        fg.filters = fg.filters.map((filter: Field) => {
          const found: Field | undefined = this.advDataFiltersService.straightFields.find((x: Field) => x.name === filter.name);
          if (found && Array.isArray(found.field_options)) {
            filter.field_options = cloneDeep(found.field_options);

            filter.options = cloneDeep(found.options?.map((opt: any) => {
              if (Array.isArray(opt.field_options)) {
                const selected_option = filter.options?.find((x) => x.value === opt.value);
                opt.field_options = opt.field_options.map((f_opt: any, index: number) => {
                  f_opt.selected = (selected_option?.field_options || [])[index]?.selected || '';
                  f_opt.selected_list = (selected_option?.field_options || [])[index]?.selected_list || [];
                  return f_opt;
                })
              }
              return opt;
            }))

          }
          return filter;
        })
        return fg;
      })

      this.advFiltersService.currentView = {
        ...view,
        pined: view?.pined || false,
        name: view?.id ? view?.name : 'View-' + String((new Date().getTime())),
        cid: view?.cid || '',
        vid: view?.vid || 'v-' + String((new Date().getTime())),
      };
      if (Array.isArray(view.filters_group) && view.filters_group.length > 0) {
        this.advFiltersService.filters = (view.filters_group as Array<FilterGroup>) || [];
        this.advFiltersService.currentScreen = this.SCREENS.THREE
      } else {
        this.advFiltersService.filters = [];
        this.advFiltersService.currentScreen = this.SCREENS.ONE
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedView']) {
      if (!changes['selectedView'].currentValue) {
        this.advFiltersService.changeScreen(this.SCREENS.ONE);
      }
      this.selectedView = changes['selectedView'].currentValue;
      this.buildCurrentView();
    } else if (changes['tempView']) {
      if (!changes['tempView'].currentValue) {
        this.advFiltersService.changeScreen(this.SCREENS.ONE);
      }
      this.selectedView = changes['tempView'].currentValue;
      this.buildCurrentView();
    }
    if (changes['fields']) {
      this.advDataFiltersService.buildFields(changes['fields'].currentValue);
      this.buildCurrentView();
    }
  }

  ngOnInit(): void {
  }

  onCreateView(e: MouseEvent) {
    this.onViewNameClose('');
    // this.advFiltersService.viewNameModal = true;
    // this.create.next(this.advFiltersService.filters);
  }

  onViewNameClose (e: string) {
    this.advFiltersService.viewNameModal = false;
    this.advFiltersService.currentView.vid = 'v-' + String((new Date().getTime()));

    this.create.next({ 
      ...this.advFiltersService.currentView, 
      filters_group: this.advFiltersService.filters 
    });

    this.cd.markForCheck();
    this.cd.detectChanges();

    this.close.emit('close')
  }

  onViewModalClose(e: string) {
    this.advFiltersService.viewNameModal = false;
    // this.close.emit('close')
  }

  onApply (e: any) {
    const payload: any = {
      ...this.advFiltersService.currentView, 
      filters_group: this.advFiltersService.filters 
    }
    payload.filters_group = payload.filters_group.filter((x: FilterGroup) => !x.deleted).map((x: FilterGroup) => {
      x.filters = x.filters.filter((x: Field) => !x.deleted);
      return x;
    });
    
    if (payload.id) {
      this.update.emit(payload);
    } else {
      this.temp.emit(payload);
    }
  }

  onChange(e: any) {
    const payload: any = {
      ...this.advFiltersService.currentView, 
      filters_group: cloneDeep(this.advFiltersService.filters),
      check: true
    }
    
    payload.filters_group = payload.filters_group.filter((x: FilterGroup) => !x.deleted).map((x: FilterGroup) => {
      x.filters = x.filters.filter((x: Field) => !x.deleted);
      return x;
    });

    this.check.emit(payload);
  }

  onUpdateView (e: any) {
    this.updateview.emit(e);
  }
}
